import { Link } from "react-router-dom";

interface SiteCtaBandProps {
  title?: string;
  description?: string;
}

export default function SiteCtaBand({
  title = "手上有一条线索？欢迎丢给我们",
  description = "不管是片场花絮、平台规则争议还是消费体验翻车，都可以发邮件告诉我们。编辑会整理成话题，把评论区高能回复和投票一起放出来。",
}: SiteCtaBandProps) {
  return (
    <section className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
      <div className="overflow-hidden rounded-lg border border-background-300 bg-accent-50">
        <div className="flex flex-col gap-6 p-6 md:flex-row md:items-center md:justify-between md:p-10">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 font-label text-xs text-accent-900">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-send-plane-line" aria-hidden="true" />
              </span>
              线索征集
            </span>
            <h2 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-3xl">
              {title}
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">{description}</p>
          </div>
          <div className="flex shrink-0 flex-col gap-3 sm:flex-row md:flex-col">
            <a
              href="mailto:baoliao@example.com"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-mail-send-line" aria-hidden="true" />
              </span>
              baoliao@example.com
            </a>
            <Link
              to="/about"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              了解我们的内容原则
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}